export default "__VITE_ASSET__fAT6QlAW__"